import React from 'react';

import { RealTimeNotification } from './real-time-notification';

import { capitalize } from '../../util/formatters';

type Props = {
  messageType: string;
  senderName: string;
  messageBody: string;
  subtitle: string;
  onClose: () => void;
  onView: () => void;
  onMarkAsRead: () => void;
};

export const IncomingMessageNotification = ({
  messageType,
  senderName,
  messageBody,
  subtitle,
  onClose,
  onView,
  onMarkAsRead,
}: Props) => (
  <RealTimeNotification
    messageBody={messageBody}
    subtitle={subtitle}
    title={`${capitalize(messageType)} from ${senderName}`}
    onClose={onClose}
    actions={
      <div className="u-margin-top u-display-flex u-justifyContent-spaceBetween">
        <div role="presentation" className="typo-link" onClick={onView}>
          View Message
        </div>
        <div role="presentation" className="typo-link" onClick={onMarkAsRead}>
          Mark As Read
        </div>
      </div>
    }
  />
);
